enum BcCareConnectDomain {
    Documents = "documents",
    Imaging = "imaging",
    Labs = "plis"
}

export { BcCareConnectDomain };
